'use client';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import Link from 'next/link';

import { sliderButtonThemes } from 'app/utility/themes';
import SwiperButtonPrev from 'app/components/common/SwiperButtonPrev';
import SwiperButtonNext from 'app/components/common/SwiperButtonNext';
import WithSwiper from 'app/components/common/WithSwiper';
import { IMassMediaPost } from 'app/interfaces/posts';
import MediaCard from './MediaCard';

interface MediaProps {
  items: IMassMediaPost[];
}

export default function Media({ items }: MediaProps) {
  return (
    <section className="flex flex-col gap-9 md:gap-20 xl:gap-15 w-full wrapper-main wrapper-max pt-27 md:pt-25 xl:pt-28 pb-21 md:pb-15 xl:pb-20">
      <div className="flex justify-between items-center">
        <h2 className="text-h1 text-brown">СМИ о нас</h2>
        <Link
          className="p-2.5 pb-2 text-h2 border border-brown rounded"
          href="/media/"
        >
          Ко всем
        </Link>
      </div>
      <div>
        <Swiper
          slidesPerView={1}
          spaceBetween={12}
          breakpoints={{
            768: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            1280: {
              slidesPerView: 4,
              spaceBetween: 20
            }
          }}
          className="[&_.swiper-wrapper]:items-stretch [&_.swiper-wrapper]:pb-1 [&_.swiper-slide]:h-auto [&_.swiper-slide]:flex [&_.swiper-slide]:flex-col"
        >
          {items.map((item, index) => (
            <SwiperSlide key={index}>
              <MediaCard
                post={item}
                className="grow"
              />
            </SwiperSlide>
          ))}
          <WithSwiper>
            {({ isLocked }) =>
              !isLocked && (
                <div className="absolute z-10 right-0 bottom-0 flex gap-1 justify-end">
                  <SwiperButtonPrev theme={sliderButtonThemes.graphite} />
                  <SwiperButtonNext theme={sliderButtonThemes.graphite} />
                </div>
              )
            }
          </WithSwiper>
        </Swiper>
      </div>
    </section>
  );
}
